exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/modules/_object-gops.js
// module id = ../../../../core-js/modules/_object-gops.js
// module chunks = 4